export default "__VITE_ASSET__BGmCOFrg__"